import React, {useContext} from 'react';
import {Link, useParams} from 'react-router-dom';
import {Button, Col, Row} from 'react-bootstrap';
import AuditContext from '../Utils/context.js';

export default function Proof() {

  const {employeeId} = useParams();
  const {schedule} = useContext(AuditContext);

  const getVariant = (form) => {

    switch (true) {
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'success';
      case (form?.SUBMIT_AT !== null && form?.SUBMIT_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  return (
    <Row>
      {schedule.forms && schedule.forms.map((form, key) => {
        if (form.SUBMIT_BY === null) {
          return (
            <Col key={key}  md={4}>
              <Link to={`/auditor/${employeeId}/proofs/${form.FORM_ID}`}>
                <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
              </Link>
            </Col>
          );
        } else {
          return (
            <Col key={key}  md={4}>
              <Link to={`/auditor/${employeeId}/evaluations/${form.FORM_ID}`}>
                <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
              </Link>
            </Col>
          )
        }
      })}
    </Row>
  )
}